/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import './SingleSelect.scss'

const SingleSelect = props => {

    //int representing current selected option index
    const [selected, setSelected] = useState(-1);
    const [disabled, setDisabled] = useState(false);

    //feedback is obj representing current feedback text, gotten from data.options.feedback
    //null means no current feedback
    const [feedback, setFeedback] = useState(null);

    const data = props.data;
    // {
    //     questionText:"what is the answer?",
    //     options:[
    //         {
    //             "text":"whatever answer text",
    //             "correct":false,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         },
    //         {
    //             "text":"whatever answer text2",
    //             "correct":true,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         },
    //         {
    //             "text":"whatever answer text3",
    //             "correct":false,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         }
    //     ]
    // }


    const handleOptionClick = (optionIndex) => {
        setDisabled(true)
        if(selected === -1){
            setSelected(optionIndex)
            if(props.setCurrentChoice) props.setCurrentChoice(optionIndex)
        }
    }

    const handleCloseFeedback = () => {
        if(data.options[selected].correct){
            //correct
            props.onComplete("");
        }else{
            //incorrect
            setSelected(-1)
        }
    }

    useEffect(()=>{
        console.log('selected changed', selected);
        if(data.options[selected]){
            setFeedback(data.options[selected].feedback)
        }else{
            setFeedback(null)
        }
    }, [selected])

    return (
        <div className="SingleSelect">
            {/* <div className={`debug`}>
                Current: {selected}
            </div> */}
            {data.header && <div className={`header`} dangerouslySetInnerHTML={{__html:data.header}}></div>}
            {data.questionText && <div className={`question-text`} dangerouslySetInnerHTML={{__html:data.questionText}}></div>}

            <div className={`options`}>
                {
                    data.options.map((option, optionIndex) => {
                        return <div className={`option global-button ${option.text.toLowerCase() + '-but'} ${selected === optionIndex ? 'selected' : "not-selected"} ${disabled ? 'disabled': ''}`} onClick={()=>handleOptionClick(optionIndex)}>                            
                            {                               
                                selected === optionIndex &&  
                                //if has feedback
                                (feedback ?                
                                <div className={`feedback`}>
                                    <h1>{feedback.header}</h1>
                                    <div className={`feedback-body`} dangerouslySetInnerHTML={{__html:feedback.body}}>
                                    </div>
                                    <div className={`feedback-button`} onClick={handleCloseFeedback}>{feedback.button}</div>
                                </div> 
                                //else
                                :                                 
                                props.onComplete())
                            }
                             <div className={`${option.text.toLowerCase()+'-icon'}`}></div>{option.text}
                        </div>
                    })
                }
            </div>


        </div>
    )
}

export default SingleSelect